import {
  AfterViewInit,
  Component,
  OnInit,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { finalize, from, Subscription, switchMap } from 'rxjs';
import { PublicService } from './openAPI/api/public.service';
import { AlertManagerService } from './shared/services/alert/alert.manager.service';
import { ConfigService } from './shared/services/config/config.service';
import { ModalManagerService } from './shared/services/modal/modal-manager.service';
import { ViewportScroller } from '@angular/common';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, AfterViewInit {
  readonly MAIN_CONTENT_ID = 'main';

  @ViewChild('genericMessageRefContainer', { read: ViewContainerRef })
  genericMessageRefContainer!: ViewContainerRef;

  constructor(
    private publicSrv: PublicService,
    private configSrv: ConfigService,
    public alertManager: AlertManagerService,
    public viewportScroller: ViewportScroller,
    private modalManager: ModalManagerService
  ) {}

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.alertManager.genericMessageRefContainer =
        this.genericMessageRefContainer;
      this.modalManager.genericMessageRefContainer =
        this.genericMessageRefContainer;
    }, 0);
  }

  ngOnInit(): void {
    // Temporary fix
    const sub: Subscription = this.publicSrv
      .getInfo('body', false, {
        httpHeaderAccept: 'application/text',
      })
      .pipe(
        switchMap((response: unknown) => from((response as Blob).text())),
        finalize(() => sub.unsubscribe())
      )
      .subscribe((versionBE: string) => {
        console.log('BE version', versionBE);
        console.log('FE version', this.configSrv.getAllConf().version);
      });
  }

  onChangeEveryRoute() {
    if (this.alertManager.alertInstanced.length > 0) {
      this.alertManager.closeAllAlerts();
    }
    if (this.modalManager.modalInstanced.length > 0) {
      this.modalManager.closeAllModals();
    }

    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  }
}
